module.exports = __webpack_public_path__ + "assets/img/Srf_Logo-1-transparent.1de9a098.png";